<template>
  <div
    class="group flex items-center border-b border-gray-700 px-4 transition-colors duration-150"
    :class="{ 'bg-primary-500/20': isSelected }">
    <Video size="14" class="mr-2 text-blue-400" />
    <div class="flex-1" @click="$emit('click')">
      <div class="text-gray-200">{{ name }}</div>
      <div class="text-sm text-blue-400">Media Source</div>
    </div>
  </div>
</template>

<script setup>
import { Video } from 'lucide-vue-next';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
</script>
